/* global axios */
import ApiClient from '../ApiClient';

class HttpToolsAPI extends ApiClient {
  constructor() {
    super('agno/custom_tools', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, { custom_tool: data });
  }

  update(id, data) {
    return axios.put(`${this.url}/${id}`, { custom_tool: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  test(id, testParams = {}) {
    return axios.post(`${this.url}/${id}/test`, { test_params: testParams });
  }

  getHttpMethods() {
    return axios.get(`${this.url}/http_methods`);
  }

  getAuthTypes() {
    return axios.get(`${this.url}/auth_types`);
  }
}

export default new HttpToolsAPI();
